import { Show } from "solid-js";
import { useChatRuntime } from "../../runtime/ChatRuntime";
import type { ActionItem } from "./chiefSchema";

export const ActionStatusChip = (props: { enabled: boolean }) => {
  const { t } = useChatRuntime();
  return (
    <Show
      when={props.enabled}
      fallback={
        <span class="shrink-0 rounded-full bg-primary-border/50 px-1.5 py-0.5 text-[10px] leading-none font-medium text-muted-text">
          {t("chief_actions_card.paused")}
        </span>
      }
    >
      <span class="shrink-0 rounded-full bg-brand/10 px-1.5 py-0.5 text-[10px] leading-none font-medium text-brand">
        {t("chief_actions_card.active")}
      </span>
    </Show>
  );
};

export const actionHintKey = (
  action: ActionItem
): "chief_actions_card.scheduled" | "chief_actions_card.triggered" | null => {
  if (action.schedule) return "chief_actions_card.scheduled";
  if (action.trigger) return "chief_actions_card.triggered";
  return null;
};
